<script setup>
import { RouterLink } from 'vue-router';
import Trans from '@/i18n/translation';
import GamebookLogo from '@/components/GamebookLogo.vue';

const homeNavigation = Trans.i18nRoute({ name: 'home' });
</script>

<template>
  <header class="bg-primary text-basecolor">
    <nav class="mx-auto flex items-center justify-between p-6 lg:px-8">
      <div class="flex items-center gap-x-12">
        <RouterLink
          :to="homeNavigation"
          class="-m-1.5 p-1.5 inline-flex"
        >
          <span class="sr-only">{{ $t('appTitle') }}</span>
          <GamebookLogo
            :dark="true"
            class="flex-col h-12 w-auto rounded-lg"
          />
          <span class="font-black p-3 flex-col text-basecolor">{{ $t('appTitle') }}</span>
        </RouterLink>
      </div>
    </nav>
  </header>
</template>
